/**
 * Trigger a browser download for an in-memory Blob. Builds a temporary object
 * URL, clicks a hidden `<a download=...>`, then revokes the URL. Mirrors the QR
 * download pattern but works for arbitrary binary payloads (e.g. PDFs).
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke on the next tick so the browser has started the download first.
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
};

/**
 * Build a filesystem-safe filename fragment from an arbitrary label. Collapses
 * anything that is not a letter/number/dash/underscore into a single dash and
 * trims leading/trailing dashes. Falls back to `fallback` when empty.
 */
export const safeFilenamePart = (label: string, fallback: string): string => {
  const cleaned = label
    .trim()
    .replace(/[^\p{L}\p{N}_-]+/gu, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  return cleaned || fallback;
};
